<template>
    <AuthLayout>
        <form @submit.prevent="submit">

            <FormGroup :label="__('admin::labels.email')" :error="errors.email">
                <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" autocomplete="username" autofocus />
            </FormGroup>

            <FormGroup :label="__('admin::labels.password')" :error="errors.password">
                <Input name="password" type="password" :has-error="exists(errors.password)" v-model="form.password" :required="true" autocomplete="current-password" autofocus />
            </FormGroup>

            <div class="block">
                <Checkbox name="remember" v-model:checked="form.remember" :label="__('admin::auth.remember_me')" />
            </div>

            <div class="flex items-center justify-end mt-6">
                <Button :block="true" :loading="form.processing">
                    {{ __('admin::auth.sign_in_cta') }}
                </Button>
            </div>

            <div class="flex justify-center mt-6">
                <InertiaLink :href="$route('admin::forgot-password.show')" class="text-gray-500 text-sm">
                    {{ __('admin::auth.forgot_password_link') }}
                </InertiaLink>
            </div>

        </form>
    </AuthLayout>
</template>

<script>
export default {
    props: {
        errors: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('admin::auth.store'), {
                onFinish: () => this.form.reset('password'),
            })
        }
    }
}
</script>
